const loadLazyPage = async pageName => {
  const component = await import(`../pages/${pageName}/index`)
  return { Component: component.default }
}

export default loadLazyPage
